import { render, staticRenderFns } from "./ImageOverlayCarousel.vue?vue&type=template&id=0d52cc00&scoped=true"
import script from "./ImageOverlayCarousel.vue?vue&type=script&lang=ts"
export * from "./ImageOverlayCarousel.vue?vue&type=script&lang=ts"
import style0 from "./ImageOverlayCarousel.vue?vue&type=style&index=0&id=0d52cc00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d52cc00",
  null
  
)

export default component.exports